import React from 'react';
import CheckboxInput from '../checkbox-input';

const BooleanRow = ({filter, updateValue}) => {
  return (
    <CheckboxInput
      className='boolean-checkbox'
      checked={filter.value}
      onChange={()=>{updateValue(!filter.value)}}
    />
  )
}

export default BooleanRow
